import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import filters, { Types as TypesFilters } from '@/app/shared/store/modules/Filters'
import dailySalesDetail from '@/app/daily_sales/store/DailySalesDetail'
import Dimension from '@/app/shared/models/Dimension'

export const NAMESPACE = 'dailySales'
const INTERNAL_NAMESPACE = NAMESPACE + '/'

const _types = {
  getters: {
    PIVOT_DIMENSIONS: 'GETTER_PIVOT_DIMENSIONS'
  },
  actions: {
    INIT: 'INIT',
    APPLY_FILTERS: 'APPLY_FILTERS',
    RESET: 'RESET'
  },
  mutations: {
    SET_DIMENSIONS: 'SET_DIMENSIONS',
    SET_METRIC: 'SET_METRIC'
  }
}

export const Types = addNamespace(INTERNAL_NAMESPACE, _types)

const Index = {
  namespaced: true,
  state: {
    dimensions: null,
    metric: null
  },
  getters: {
  },
  actions: {
    [_types.actions.INIT] ({ commit }, { dataDimensions, metric }) {
      commit(_types.mutations.SET_DIMENSIONS, dataDimensions.map((dimension) => new Dimension(dimension)))
      commit(_types.mutations.SET_METRIC, metric)
    },
    async [_types.actions.APPLY_FILTERS] ({ dispatch }, { storeFilters, productFilters, asyncProductPool }) {
      await dispatch(INTERNAL_NAMESPACE + TypesFilters.actions.SET_SELECTED_FILTERS, { storeFilters, productFilters, asyncProductPool }, { root: true })
    },
    [_types.actions.RESET] ({ dispatch }) {
      dispatch(INTERNAL_NAMESPACE + TypesFilters.actions.RESET_SELECTED_FILTERS, null, { root: true })
    }
  },
  mutations: {
    [_types.mutations.SET_DIMENSIONS] (state, dimensions) {
      state.dimensions = dimensions
    },
    [_types.mutations.SET_METRIC] (state, metric) {
      state.metric = metric
    }
  },
  modules: {
    filters,
    dailySalesDetail
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/daily_sales/store/Index.js